import type { InjectionKey } from "vue";
import type { CustomMarker } from "vue3-google-map";

export type TMapSpiderfyMarker = NonNullable<InstanceType<typeof CustomMarker>["customMarker"]>;

export interface IMapSpiderfyMarkerRegistry {
  register(data: object, marker: TMapSpiderfyMarker, getWidth: () => number): void;
  unregister(marker: TMapSpiderfyMarker): void;
}

export const mapSpiderfyMarkerRegistryKey: InjectionKey<IMapSpiderfyMarkerRegistry> =
  Symbol("map-spiderfy-marker-registry");
